exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge-light[data-v-56a8707f] {\n  background-color: #E0E0E0;\n  padding: 0.75rem;\n  font-weight: 400;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n.badge-light-active[data-v-56a8707f] {\n  background-color: #B2EBF2;\n  color: #0097A7;\n  padding: 0.75rem;\n  font-weight: 400;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-56a8707f","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/order/components/Chips.vue
// module id = 1667
// module chunks = 0